import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Inter', sans-serif;
    background: linear-gradient(135deg, #0f0c29, #302b63, #24243e);
    color: #f8fafc;
    padding: 20px;
    min-height: 100vh;
    margin: 0;
    overflow-x: hidden;
  }


`;

export default GlobalStyles;
